let cachedExchangeRate = null
const starsToUsdRate = 0.05 // 1 Star = 0.05 USD

/**
 * Gets a slightly pessimistic current exchange rate for USD to COP.
 * This returns a rate about 1% lower than the real rate to avoid overpromising.
 * @returns {Promise<number>} The (pessimistic) exchange rate or null if the request fails.
 */
export async function getCurrentExchangeRate() {
    if (cachedExchangeRate) return cachedExchangeRate
    const url = `https://v6.exchangerate-api.com/v6/${import.meta.env.VITE_APP_EXCHANGE_RATE_KEY}/latest/USD`
    const response = await fetch(url)
    const data = await response.json()
    // Apply a 2.5% pessimistic reduction to the real rate
    const realRate = data.conversion_rates.COP
    const pessimisticRate = realRate * 0.975
    cachedExchangeRate = pessimisticRate
    return cachedExchangeRate
}

/**
 * Converts a value from USD to Stars
 * @param {number} usdValue - The value in USD to convert
 * @returns {number} The value in Stars
 */
export function convertToStars(usdValue) {
    return Number((usdValue / starsToUsdRate).toFixed(2))
}

/** */
/**
 * Converts a value from Stars to USD
 * @param {number} starsValue - The value in Stars to convert
 * @returns {number} The value in USD
 */
export function convertToUsd(starsValue) {
    return Number((starsValue * starsToUsdRate).toFixed(2))
}
